var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBlokx(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 115,
    height: 32,
    viewBox: "0 0 115 32",
    fill: "current",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_625_186)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 6.47656V25.7357H15.3357L19.12 21.9513V18.5566L17.033 15.5513L18.4696 13.4644V10.5253L15.0748 6.47656H0Z",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5374 6.47656V25.7357H39.3182V19.1444H31.3947V6.47656H21.5374Z",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.1982 0L43.6696 7.3913L42.4939 18.2296L46.6748 25.4122L67.2382 5.76V4.51826L62.6678 0H50.1982Z",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.3914 26.3235V26.9774L51.9618 32H64.6922L68.2853 25.7357L69.9827 16.7931L68.3479 6.47656L67.2383 6.80352L47.3914 26.3235Z",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.3547 6.47656V25.4122H92.8V24.4974L87.1513 16L92.8 7.22787V6.47656H74.3547Z",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.1826 6.47656V7.03308L101.19 15.8122L95.1826 24.9218L95.3461 25.4122H114.052L114.313 24.7583L108.438 16L114.313 7.19656V6.47656H95.1826Z",
    fill: "current"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_625_186"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 114.313,
    height: 32,
    fill: "current"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlokx);
export default __webpack_public_path__ + "static/media/blokx.fe74b1cc512a04866ca19cc63e15b383.svg";
export { ForwardRef as ReactComponent };